import TableHeader from '@/components/table/tableHeader';
import { ISort } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';

import { Loader } from '@/components/loaders/loader';
import { TableBodyWrapper, TableWrapper } from '@/components/table/styles';
import { activityLogTableColumns } from '../../constants';
import { AllocationOperationsWorkflowTransitionHistoryDto } from '../../types';
import TableBody from './tableBody';
import MobileTable from './tableMobile';

interface TableProps {
  activityLogTableData: AllocationOperationsWorkflowTransitionHistoryDto[];
  sort: ISort;
  loading: boolean;
  refetch: () => void;
  setSort: (value: ISort) => void;
}

const Table = ({ activityLogTableData, sort, setSort, refetch, loading }: TableProps) => {
  const { isMobile } = useResponsive();

  return (
    <TableWrapper padding="0">
      {isMobile ? (
        <>{loading ? <Loader /> : <MobileTable activityLogTableData={activityLogTableData} />}</>
      ) : (
        <>
          <TableHeader refetch={refetch} columns={activityLogTableColumns} savedSort={sort} savedSetSort={setSort} />
          <TableBodyWrapper>{loading ? <Loader /> : <TableBody activityLogTableData={activityLogTableData} />}</TableBodyWrapper>
        </>
      )}
    </TableWrapper>
  );
};

export default Table;
